import { Text, TextSize, Weight } from 'components/typography'
import styled, { css } from 'styled-components'

export const BarChartWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.Mobile`
    display: flex;
    flex-direction: column;
  `};
`

export const StyledText = styled(Text)`
  font-size: ${TextSize.small};
`

export const ReturnTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const ReturnTitles = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const ReturnTitle = styled.div`
  display: flex;
  justify-content: center;
  width: 146px;
`

export const ReturnTitleText = styled(Text)`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Medium};
  color: ${({ theme }) => theme.secondaryText};
`

export const ReturnItem = styled.div<{ hoverColor: string; active: boolean }>`
  display: flex;
  align-items: center;
  height: 52px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.4s all;
  padding: 0 0 0 16px;
  > div:first-child {
    min-width: 56px;
  }
  ${({ active, hoverColor, theme }) =>
    active &&
    css`
      background-color: ${theme.switchBgColor};
      span {
        font-weight: ${Weight.Bold};
      }
      & div {
        span {
          font-weight: ${Weight.Bold};
        }
        div {
          background-color: ${hoverColor};
        }
      }
    `}
  :hover {
    background-color: ${({ theme }) => theme.switchBgColor};
    span {
      font-weight: ${Weight.Bold};
    }
    & div {
      span {
        font-weight: ${Weight.Bold};
      }
      div {
        background-color: ${({ hoverColor }) => hoverColor};
      }
    }
  }
`
export const SymbolWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-right: 20px;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.Mobile`
    max-width: 150px;
  `};
`
export const ColoredCircle = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  height: 16px;
  width: 16px;
  border-radius: 50%;
`
export const TableText = styled(Text)`
  font-size: ${TextSize.small};
  display: flex;
  flex: 1;
  justify-content: center;
`
